import * as React from "react";
import { FGCustomInput, FGSelectInput} from "nsitools-react";
import { PersonGridDto, ClubContactApi, SaveClubContactDto } from "../../../../../api";
import { SmallFormGenerator } from "../../../../../components";
import { ETLCodes } from "../../../../../locales";
import { useReferential } from "../../../../../hooks/useReferential";
import { useTl, useApiService, useSaveApi } from "../../../../../hooks";
import { useGlobalData } from "../../../../../contexts";
import { useParams } from "react-router";
import * as Yup from "yup";

export interface IClubContactFormPanelProps {
  person: PersonGridDto;
  onSaved: () => void;
}

export const ClubContactFormPanel: React.FunctionComponent<IClubContactFormPanelProps> = ({ person, onSaved }) => {
  const { t } = useTl();
  const { currentLanguage } = useGlobalData();
  const { id } = useParams<{ id: string }>();
  const clubContactApi = useApiService(ClubContactApi);
  const [roles, rloading] = useReferential(
    (a) => a.getClubRolesForContact(currentLanguage.languageId, +id, person.personId),
    true,
    [currentLanguage.languageId]
  );
  const { saving, saveItem } = useSaveApi<SaveClubContactDto>(
    React.useMemo(
      () => ({
        saveApiFn: (data) => clubContactApi.addNewContact(data),
        onSaveFn: () => onSaved(),
      }),
      [clubContactApi, onSaved]
    )
  );

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      clubRoleId: Yup.number().nullable().required(t(ETLCodes.Required)),
    });
  }, [t]);

  const initialData = React.useMemo(() => new SaveClubContactDto({ personId: person.personId, clubId: +id }), [
    id,
    person.personId,
  ]);

  return (
    <SmallFormGenerator
      validationSchema={FormSchema}
      onSubmit={saveItem}
      saving={saving}
      initialValues={initialData}
      editMode={true}
    >
      <FGCustomInput name="clubRoleId" label={t(ETLCodes.Name)}>
        {() => (
          <div style={{ paddingLeft: "10px" }}>
            {person.lastName} - {person.firstName}
          </div>
        )}
      </FGCustomInput>
      <FGSelectInput name="clubRoleId" label={t(ETLCodes.Role)} items={roles} loading={rloading} />
    </SmallFormGenerator>
  );
};
